export default __webpack_public_path__ + "static/header-showroom-c9d6112cdf49850fd10d5c4e27c113da.png";